import {PlayerReduxState} from "../types";

export default function isStartFailed(state: PlayerReduxState): boolean {
  return !!state.sessionStartFailed;
}
